import { withInstall, withNoopInstall } from '@lit-element/utils'
import Carousel from './src/carousel.vue'
import CarouselItem from './src/carousel-item.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtCarousel: SFCWithInstall<typeof Carousel> & {
  CarouselItem: typeof CarouselItem
} = withInstall(Carousel, {
  CarouselItem,
})

export default LtCarousel

export const LtCarouselItem: SFCWithInstall<typeof CarouselItem> =
  withNoopInstall(CarouselItem)

export * from './src/carousel'
export * from './src/carousel-item'
export * from './src/constants'

export type { CarouselInstance, CarouselItemInstance } from './src/instance'
